import React, { useEffect, useRef, useState, useContext } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {SettingsContext} from "@/SettingsContext";
import {useModal} from "@/ModalContext";
import axios from "axios";
import Cookies from 'js-cookie';
import {VisitedContext} from "@/VisitedContext";
import { useLocation  as useLocationContext } from '/src/LocationContext';

export default function GoogleMaps({
                            currentLocation,
                            points,
                            onItemClick
                        }) {
    const ref = useRef();
    const params = useParams();
    const location = useLocation();

    const { isModalOpen, openModal, closeModal, modalContent, updateModalContent } = useModal();

    let map = null;
    let bounds = new google.maps.LatLngBounds();
    let currentPositionMarker = null;


    const { tourSettings } = useContext(SettingsContext);
    const visitedContext = useContext(VisitedContext);

    const tourModules = tourSettings?.modules ?? []

    const [mapState, setMapState] = useState(null)
    const [currentPositionMarkerState, setCurrentPositionMarkerState] = useState(null)
    const [pointMarkersState, setPointMarkersState] = useState({})
    const [zoomChanged, setZoomChanged] = useState(false);
    const visitedPoints = visitedContext.points;
    const { getGPSPosition } = useLocationContext();

    const navigate = useNavigate();

    let markerIcons = {
        locked: '/static/markers/locked.svg',
        visited: '/static/markers/visited.svg',
        answer_correct: '/static/markers/answer_correct.svg',
        answer_wrong: '/static/markers/answer_wrong.svg',
        default: '/static/markers/default.svg'
    }
    if (window.location.hostname === "denhaag-ctrl.tourio.com" || window.location.hostname === "denhaag-ctrl.dev.tourio.com") {
        markerIcons = {
            locked: '/static/thewalk/markers/locked_new.svg',
            visited: '/static/thewalk/markers/visited_new2.svg',
            answer_correct: '/static/thewalk/markers/answer_correct_new.svg',
            answer_wrong: '/static/thewalk/markers/answer_wrong_new2.svg',
            default: '/static/thewalk/markers/default_new.svg'
        }
    }

    // Track page view
    React.useEffect(() => {
        var _paq = window._paq = window._paq || [];
        _paq.push(['setCustomUrl', location.pathname]);
        _paq.push(['setDocumentTitle', 'Points - Google maps']);
        _paq.push(['trackPageView']);
    }, [location])


    useEffect(() => {
        if (Object.keys(points).length > 0) {
            loadMap();
        } else {
            console.log("points empty on loadMap useEffect", points);
        }
    }, [mapState, points, currentLocation])


    function getIconUrl(point) {

        if (tourSettings.navigation?.google_maps?.show_point_icons && point.data?.icon) {
            return point.data.icon.preview_url;
        }

        // check if game module is activated and check game settings to override the icon
        if (tourModules.includes('game')) {
            const gameCollectables = point.data?.settings?.game?.collectables; // consumable items
            if (gameCollectables) {
                console.log("point", point.data);
                console.log("gameCollectables", gameCollectables.items.length);
                console.log(gameCollectables.items[0]);
                console.log("page length: ", point.data?.pages);
                let item = gameCollectables.items[0]?.object
                if (item && item.image && point.data?.pages.length===0) {
                    console.log( item.image);
                    return item.image.preview_url;
                }
            }
        }

        return markerIcons[point.state] || markerIcons.default;
    }

    /**
     * Creates a control that recenters the map on Chicago.
     */
    function createCenterControl(map) {
        const controlButton = document.createElement("button");

        // Set CSS for the control.
        controlButton.style.backgroundColor = "#fff";
        controlButton.style.border = "2px solid #fff";
        controlButton.style.borderRadius = "3px";
        controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlButton.style.color = "rgb(25,25,25)";
        controlButton.style.cursor = "pointer";
        controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
        controlButton.style.fontSize = "16px";
        controlButton.style.lineHeight = "38px";
        controlButton.style.margin = "8px 0 22px";
        controlButton.style.padding = "0 5px";
        controlButton.style.textAlign = "center";
        controlButton.textContent = "Center Map";
        controlButton.title = "Click to recenter the map";
        controlButton.type = "button";
        controlButton.id = "ctrlCenterButton";
        // Setup the click event listeners: simply set the map to Chicago.
        controlButton.addEventListener("click", () => {
            if (currentLocation.lat > 0 && currentLocation.lng > 0) {
                map.setCenter({lat: currentLocation.lat, lng: currentLocation.lng});
            }
            document.getElementById("ctrlCenterButton").style.visibility = "hidden";
            setZoomChanged(false)

        });
        return controlButton;
    }

    // const getGPSPosition = (position) => {
    //     if (position) {
    //         let LatLng = position.replace("(", "").replace(")", "").split(", ")
    //         if (LatLng.length === 2) {
    //             let Lat = parseFloat(LatLng[0]);
    //             let Lng = parseFloat(LatLng[1]);

    //             if (Lat > 0 && Lng > 0) {
    //                 return {lat: Lat, lng: Lng}
    //             }
    //         }
    //     }

    // }

    const loadMap = () => {
        if (!mapState) {

            map = new google.maps.Map(ref.current, {
                center: {lat: currentLocation.lat, lng: currentLocation.lng},
                streetViewControl: false,
                zoomControl: false, // to avoid center button is not triggered
                zoom: 17,
                heading: (currentLocation.heading && currentLocation.speed >= 0.9) ? currentLocation.heading : 0,
                tilt: 45,
                mapId: "5cbd1c73e59850a", // Google Maps rotation including Tourio default style
                //mapId: "90f87356969d889c", // See example at https://stackoverflow.com/questions/70288775/problem-trying-to-rotate-a-map-with-google-maps-api
            });
            map.addListener('dragstart', function(e) {
                document.getElementById("ctrlCenterButton").style.visibility = "visible";
                setZoomChanged(true);
            });

            // Create the DIV to hold the control.
            const centerControlDiv = document.createElement("div");
            // Create the control.
            const centerControl = createCenterControl(map);
            centerControl.style.visibility = "hidden";

            // Append the control to the DIV and map.
            centerControlDiv.appendChild(centerControl);
            map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(centerControlDiv);


            let markers = pointMarkersState;
            // add location point markers
            for (const [pointId, point] of Object.entries(points)) {

                let pos = getGPSPosition(point.data.gps_location);
                if (!pos) {
                    console.log("no valid position found for point " + point.data.id);
                    continue;
                }
                console.log("extend boud with point " + point.data.id);

                let position = new google.maps.LatLng(pos);

                bounds.extend(position);

                // load icon based on state
                const iconUrl = getIconUrl(point);
                console.log("icon:" + iconUrl);

                let label = {text: point.data.order.toString(), color: "black", className: "markerLabel"}

                if (window.location.hostname === "denhaag-ctrl.tourio.com" || window.location.hostname === "denhaag-ctrl.dev.tourio.com") {
                    label = null;
                }

                if (iconUrl.includes('/client/mediafile/')) {
                    // we have custom icons, hide label with point order number
                    label = null;
                }

                // add marker
                let marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    title: point.data.name,
                    icon: {
                        url: iconUrl,
                        scaledSize: new google.maps.Size(36, 36)
                    },
                    label: label
                });
                // add click event
                google.maps.event.addListener(marker, 'click', (function(marker, point) {
                    return function() {
                        // if not locked and has a point id
                        if (!point.locked && typeof point !== "undefined" && typeof point.data.point.id !== "undefined") {

                            // check if there is a game_conditions property
                            console.log("point clicked", point);
                            console.log("visited points", Object.keys(visitedPoints));

                            // TODO add collectable game object items here so we can fake Geofence entrance

                            // mark as false when the game module is active to check game dynamics as condition to enter the point
                            let checkPassed = !tourModules.includes('game');

                            // check if game module is activated for game dynamics to see if there are conditions to enter a point
                            if (tourModules.includes('game')) {

                                const gameConsumables = point.data?.settings?.game?.consumables; // consumable items
                                const gameCollectables = point.data?.settings?.game?.collectables; // consumable items

                                console.log("Point has consumables? ", gameConsumables);
                                console.log("Point has collectables? ", gameCollectables);
                                console.log("Already visited?", point.data.id, Object.keys(visitedPoints).includes(point.data.point.id));

                                if (gameConsumables && !Object.keys(visitedPoints).includes(point.data.point.id.toString())) {
                                    console.log("game dynamics checken", gameConsumables);

                                    // check inventory
                                    const existingInventory = (Cookies.get('inventory')) ? JSON.parse(Cookies.get('inventory')) : {};

                                    console.log("existingInventory", existingInventory);


                                    // loop through the required objects and validate the inventory

                                    const objectItems = gameConsumables?.items ?? {};
                                    console.log("Object items", objectItems);
                                    if (Object.keys(objectItems).length > 0) {
                                        // Initialize checkPassed as false before checking
                                        checkPassed = false;

                                        // Use a variable to track if all conditions are met
                                        const allConditionsMet = Object.values(objectItems).every((item) => {
                                            console.log(item, item.object_id);

                                            const existingItem = Object.values(existingInventory).find(inventory => inventory.object_id === item.object_id);

                                            if (existingItem) {
                                                // check if we have enough value in the inventory for this object
                                                let qty = existingItem['quantity'];

                                                console.log("quantity check", qty, item.amount);

                                                if (qty >= item.amount) {
                                                    console.log("check passed for this item!", item);
                                                    return true; // This item's condition is met
                                                } else {
                                                    console.log("object found in inventory, but amount too short", item);
                                                    console.log("check failed for this item!");
                                                    return false; // This item's condition is not met
                                                }
                                            } else {
                                                console.log("object not found in inventory", item);
                                                console.log("check failed for this item!");
                                                return false; // This item's condition is not met
                                            }
                                        });

                                        // Set checkPassed based on whether all conditions were met
                                        checkPassed = allConditionsMet;
                                    } else {
                                        console.log("we have consumables, but without items. So we can continue.");
                                        checkPassed = true;
                                    }


                                    console.log("has access (do we have enough amount of the objects)?", checkPassed);


                                    if (checkPassed) {

                                        // remove items from inventory since they are consumed
                                        Object.values(gameConsumables.items).forEach((item) => {

                                            const existingItemIndex = Object.values(existingInventory).findIndex(inventory => inventory.object_id === item.object_id);

                                            if (existingInventory[item.object_id]) {

                                                console.log("object found in inventory. ", item, existingInventory, existingInventory[item.object_id]);

                                                if (Boolean(item.consumable) || Boolean(item.object?.consumable)) {
                                                    console.log("object found, updating qty ", item, existingInventory, existingItemIndex);

                                                    // TODO check if the point is already visited, otherwise it will consume the object over and over again for the same point when revisiting.

                                                    // update the qty
                                                    existingInventory[item.object_id].quantity -= item.amount;

                                                    if (existingInventory[item.object_id].quantity <= 0) {
                                                        // remove the object from the inventory list if there are no items left
                                                        // delete existingInventory[item.object_id]; // TODO this will release the already picked up items again.. should that be possible?
                                                    }

                                                    // Update the session cookie with the updated inventory
                                                    Cookies.set('inventory', JSON.stringify(existingInventory), {expires: 1}); // Expires in 1 day
                                                } else {
                                                    console.log("Object is marked as reusable. No update quantity required.");
                                                }


                                            } else {
                                                console.log("object not found in inventory. HOW!? ", item, existingInventory, existingItemIndex);
                                            }
                                        })


                                        // game consumables found and valid. checks passed.
                                        console.log("game consumables found and valid. checks passed.");
                                        checkPassed = true;
                                        // TODO do we want a success message for consumed as well?

                                    } else {
                                        if (gameConsumables.message.length > 0) {
                                            openModal({
                                                    intro: gameConsumables.message,
                                                    //  point: point,
                                                    buttonText: 'ok'
                                                },
                                                //`/${params.language ? `${params.language}/` : ''}point/${pointId}`
                                            );
                                        }
                                    }

                                } else {
                                    // no game dynamics available, so we can continue
                                    checkPassed = true;
                                }

                                if (checkPassed && gameCollectables && gameCollectables.items.length > 0) {
                                    console.log("collectable game object items checken", gameCollectables);
                                    let inventoryChanged = false;

                                    let item = gameCollectables.items[0]; // TODO check this for all collectable items

                                    console.log(item);

                                    console.log('click', marker, item, point);


                                    // add to inventory
                                    const existingInventory = Cookies.get('inventory') ? JSON.parse(Cookies.get('inventory')) : {};

                                    console.log("existing inventory", existingInventory);

                                    // Check if the object already exists in the inventory
                                    const existingItem = Object.values(existingInventory).find(inventory => inventory.object_id === item.object_id);
                                    if (existingItem) {

                                        console.log("object found in the inventory. increase quantity", existingItem);

                                        // If the object exists, update the quantity
                                        const existingPoint = Object.values(existingItem.points).find(item => {
                                            console.log(item, point.id, point.data.point.id);
                                            return item.id === point.data.point.id
                                        });
                                        if (!existingPoint) {

                                            existingItem.quantity += item.amount;
                                            existingItem.points.push({
                                                id: point.data.point.id
                                            }) // TODO this should be the object_id.. or renamed to locations/points since it showing the pick-up location.
                                            inventoryChanged = true;
                                        } else {
                                            console.log("we already were at this point. You can pick up items only once.");
                                        }

                                    } else {

                                        console.log("object not found in the inventory, create a new record.");

                                        // If the object does not exist, add it to the inventory
                                        existingInventory[item.object_id] = {
                                            "object_id": item.object_id,
                                            "points": [{
                                                id: point.data.point.id
                                            }], // TODO this should be the object_id.. or renamed to locations/points since it showing the pick-up location.
                                            "quantity": item.amount,
                                            "consumable": item.object?.consumable ?? true
                                        };
                                        inventoryChanged = true;
                                    }

                                    console.log("new inventory", existingInventory);

                                    // Update the session cookie with the updated inventory
                                    Cookies.set('inventory', JSON.stringify(existingInventory), {expires: 1}); // Expires in 1 day

                                    if (inventoryChanged && gameCollectables.message.length > 0) {
                                        console.log("show messsage:", gameCollectables.message);
                                        openModal({
                                            intro: gameCollectables.message,
                                            //  point: point,
                                            buttonText: 'ok',
                                            },
                                            point.data.pages.length >0 ? point.data : null
                                        );
                                        // we navigate by clicking ok button after reading the message
                                        checkPassed = false;
                                    }

                                    console.log("hide from the map when picked up.");
                                    console.log(point.data);

                                    if (point.data.pages.length === 0) {

                                        // hide from the map when picked up.
                                        marker.setMap(null); // hide the item from the map

                                        // we have nowhere to go to. do not navigate to the point itself.
                                        checkPassed = false;
                                    }

                                }
                            }

                            if (checkPassed) {

                                // TODO show a modal here
                                // openModal({
                                //         intro: 'Dit is punt...',
                                //         point: point,
                                //         buttonText: 'bekijk informatie'},
                                //     `/${params.language ? `${params.language}/` : ''}point/${pointId}`
                                // );

                                console.log(`all checks passed.`);

                                // Replace direct navigation with onItemClick if provided
                                if (onItemClick) {
                                    console.log("handle onItemClick", point.data.id, point);
                                    onItemClick(point.data, false);
                                } else {
                                    console.log(` navigate to /${params.language ? `${params.language}/` : ''}point/${point.data.point.id}`);
                                    // Fallback to direct navigation if onItemClick is not provided
                                    navigate(`/${params.language ? `${params.language}/` : ''}point/${point.data.point.id}`);
                                }
                            }

                        }
                    }
                })(marker, point));

                if (point.locked) {
                    marker.setCursor("default");
                } else {
                    marker.setCursor("pointer");
                }

                markers[point.data.point.id] = marker;

            }
            // only save markers if the points are loaded
            if (markers.length > 0) {
                setPointMarkersState(markers);
                console.log("setPointMarkersState", markers);
            } else {
                console.log("markers emty at setPointMarkersState");
            }


            console.log("bounds", bounds);




            // for( let i = 0; i < points.length; i++ ) {
            //     var position = new google.maps.LatLng(points[i][1], points[i][2]);
            //     bounds.extend(position);
            //     let marker = new google.maps.Marker({
            //         position: position,
            //         map: map,
            //         title: points[i][0]
            //     });
            //
            //     // Add info window to marker
            //     google.maps.event.addListener(marker, 'click', (function(marker, i) {
            //         return function() {
            //             console.log("clicked", marker);
            //            // infoWindow.setContent(infoWindowContent[i][0]);
            //            // infoWindow.open(map, marker);
            //         }
            //     })(marker, i));
            //
            //     // Center the map to fit all markers on the screen
            //     map.fitBounds(bounds);
            // }


            // add current position marker
            let currentPosition = {lat: currentLocation.lat, lng: currentLocation.lng}
            currentPositionMarker = new window.google.maps.Marker({
                position: currentPosition,
                map: map,
                icon: {
                    url: '/static/markers/current-position.svg',
                    scaledSize: new window.google.maps.Size(30, 30)
                }

            });
            setCurrentPositionMarkerState(currentPositionMarker);


            // Center the map to fit all markers on the screen (and add padding(px) to the markers as bounds)
            map.fitBounds(bounds, 10);

            setMapState(map);
        } else {


            let map = mapState;
            let markers = pointMarkersState;

            console.log("[pointMarkersState] loaded markers:", points, markers);
            for (const [pointId, point] of Object.entries(points)) {
                if (typeof markers[pointId] !== "undefined") {
                    console.log("check marker point " + pointId, point, markers[pointId]);
                    markers[pointId].setIcon({
                        url: getIconUrl(point),
                        scaledSize: new google.maps.Size(36, 36)
                    }); // update the icon

                    if (point.locked) {
                        markers[pointId].setCursor("default");
                    } else {
                        markers[pointId].setCursor("pointer");
                    }
                } else {
                    console.log("[pointMarkersState] marker for point " + point.data.order + " undefined.");
                }
            }

            if (currentLocation.lat > 0 && currentLocation.lng > 0) {

                let currentPosition = {lat: currentLocation.lat, lng: currentLocation.lng};


                // TODO check fitbound + padding (or visible region) when current position is outside range
                // let inBoundRange = false;
                // if (map.getBounds().contains(currentPosition)) {
                //     inBoundRange = true;
                //     console.log("Current position is inside bounds");
                // } else {
                //     console.log("Current position is outside bounds");
                // }


                // update current position marker
                currentPositionMarker = currentPositionMarkerState;
                currentPositionMarker.setPosition(currentPosition);
                setCurrentPositionMarkerState(currentPositionMarker);


                // update center to current position if the map is not dragged manually
                if (!zoomChanged) {

                    map.setCenter({lat: currentLocation.lat, lng: currentLocation.lng});

                    // rotate map when speed is >= 1 meter/sec
                    if (currentLocation.speed >= 0.9) {

                        if (currentLocation.heading) {
                            // set only heading if we go fast enough
                            map.setHeading(currentLocation.heading)
                        }


                        if (currentLocation.speed >= 3.0) {
                            // cycling
                            map.setZoom(17); // reset to default
                        } else {
                            // walking
                            map.setZoom(18.5);
                        }
                    } else {
                        // walking slowly or stand stil, zoom out to see where you are
                        map.setZoom(17);
                    }

                }

            }


        }
    }

    return (
        <div>
        <div style={{"display": "none", "backgroundColor": "black", "color": "white", "position": "absolute", "zIndex": "4"}}>
            current location: {JSON.stringify(currentLocation.lat)}, {JSON.stringify(currentLocation.lng) }<br/>
            heading: { Math.round(currentLocation.heading * 100) / 100 } - { Math.round(mapState?.getHeading() * 100) / 100 }<br/>
            speed: { Math.round(currentLocation.speed * 100) / 100 }<br/>
            manual view: { JSON.stringify(zoomChanged) }<br/>
            zoom: { Math.round(mapState?.getZoom() * 100) / 100 }<br/>
            {/*point 1: { JSON.stringify(points[Object.keys(points)[0]])}<br/>*/}
            {/*point 2: { JSON.stringify(points[Object.keys(points)[1]])}<br/>*/}
            {/*point 3: { JSON.stringify(points[Object.keys(points)[2]])}<br/>*/}

        </div>
        <div ref={ref} id="map">


            {/*{mapState && currentLocation && Object.keys(points).map((id) => (*/}
            {/*    <div key={id} id={points[id].id}>{points[id].name}</div>*/}
            {/*))}*/}


            {/*{mapState && currentLocation && (*/}
            {/*    <DefaultMarker*/}
            {/*        map={mapState}*/}
            {/*        position={currentLocation}*/}
            {/*    />*/}
            {/*)}*/}



        </div>
        </div>
    );
}